// This will prevent the login page from being rendered
// if the user manually navigates to login

import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function PublicRoute({ children }) {
    const { userInfo } = useSelector(
        (state) => state.auth
    )

    if (userInfo) {
        if (userInfo.Role === "A") {
            return <Navigate to="/admin" replace />
        }

        if (userInfo.Role === "U") {
            return <Navigate to="/user" replace />
        }
    }

    return children;
}

export default PublicRoute;